import { z } from "zod/v4";

import {
  IntegrationStatusList,
  OrganizationDtoSchema,
} from "../../../dtos/organizations";

export const PatchOrganizationRequestBodySchema = z.object({
  domain: z.string().optional(),
  freeTrialExpiresAtTs: z.number().optional(),
  integrationStatus: z.enum(IntegrationStatusList).optional(),
});

export type PatchOrganizationRequestBodyType = z.infer<
  typeof PatchOrganizationRequestBodySchema
>;

export const PatchOrganizationResponseBodySchema = z.object({
  org: OrganizationDtoSchema,
});

export type PatchOrganizationResponseBodyType = z.infer<
  typeof PatchOrganizationResponseBodySchema
>;
